import React, { useState } from 'react';
import BrandSlider from '../components/BrandSlider';
import styles from './Contact.module.css';
import contactIllustration from '../assets/contact-referal-2.jpg';

function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();

    const subject = encodeURIComponent(`Contact enquiry from ${form.name}`);
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\n\nMessage:\n${form.message}`
    );

    window.location.href = `mailto:info@saisenaimpex.com?subject=${subject}&body=${body}`;
  }

  return (
    <section className={styles.topSection}>
      <div className={styles.heroRow}>
        <div className={styles.left}>
          <img src={contactIllustration} alt="Contact" className={styles.illustration} />
        </div>
        <div className={styles.right}>
          <h2 className={styles.heading}>Contact Us</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Your Name..."
              className={styles.input}
              value={form.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Your E-mail Address..."
              className={styles.input}
              value={form.email}
              onChange={handleChange}
              required
            />
            <textarea
              name="message"
              placeholder="Your Message..."
              className={styles.textarea}
              rows={4}
              value={form.message}
              onChange={handleChange}
              required
            />
            <button type="submit" className={styles.sendBtn}>
              Send
            </button>
          </form>
        </div>
      </div>
      <div className={styles.clientsRow}>
        <h3 className={styles.clientsTitle}>Our Clients</h3>
        <div className={styles.clientsLogos}>
          <BrandSlider />
        </div>
      </div>
    </section>
  );
}

export default Contact;
